import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useCallback } from 'react';

export const useTrackTrustLinkClick = () => {
	const { track } = useAnalyticsContext();

	return useCallback(() => {
		track({
			event: 'CTA Clicked',
			properties: {
				action: 'reviews policy',
			},
		});
	}, [track]);
};
